module.exports = __webpack_public_path__ + "img/biter-die-4.1abdb489.png";